import {
  PublicClientApplication,
  InteractionRequiredAuthError
} from '@azure/msal-browser'

export default class AuthService {
  constructor() {
    const redirectUri = process.env.VUE_APP_REDIRECT_URI
    const msalConfig = {
      auth: {
        clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AUTH_TENANT_ID}`,
        redirectUri: `${redirectUri}/`,
        postLogoutRedirectUri: `${redirectUri}/login`,
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: 'localStorage'
      }
    }
    this.applicationConfig = {
      scopes: ['openid', 'offline_access', process.env.VUE_APP_AUTH_AUDIENCE]
    }
    this.app = new PublicClientApplication(msalConfig)
  }

  async login() {
    try {
      const sesion = JSON.parse(localStorage.getItem('sesion'))
      if (!sesion) throw new InteractionRequiredAuthError()
      const silentRequest = {
        loginHint: sesion.nombreUsuario,
        ...this.applicationConfig
      }
      return await this.app.ssoSilent(silentRequest)
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        return this.app.loginPopup(this.applicationConfig)
      }
      throw error
    }
  }

  async logout(username) {
    const logoutRequest = {
      account: this.app.getAccountByUsername(username)
    }
    await this.app.logoutPopup(logoutRequest)
  }

  getToken() {
    return this.app.acquireTokenSilent(this.applicationConfig).then(
      (response) => response.accessToken,
      () => {
        return this.app.acquireTokenPopup(this.applicationConfig).then(
          (response) => response.accessToken,
          (err) => {
            throw err
          }
        )
      }
    )
  }
}
